import Cocoen from './cocoen-fork/cocoen';

import "./cocoen-fork/cocoen.scss";

$(() => {
  $(".cocoen:not(.cocoen-lazy)").each((i, el) => {
    new Cocoen(el);
  })
});
